import React, { useEffect, useState } from 'react';
import { Button, Input, Modal, Radio } from 'antd';
import { useTranslation } from 'react-i18next';
import { RegenerationReason } from '../../services/analytics/events';

const REASON_KEYS = [
  RegenerationReason.WrongStyle,
  RegenerationReason.WrongColors,
  RegenerationReason.WrongFoodItem,
  RegenerationReason.LowQuality,
  RegenerationReason.DoesntMatchBrand,
  RegenerationReason.TextIssues,
  RegenerationReason.Other,
];

export default function RegenerationReasonModal({ open, onCancel, onConfirm }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Modals:Marketing:RegenerationReasonModal' });

  const [reason, setReason] = useState(null);
  const [details, setDetails] = useState('');

  useEffect(() => {
    if (!open) {
      setReason(null);
      setDetails('');
    }
  }, [open]);

  function handleConfirm() {
    onConfirm(reason, details.trim() || null);
  }

  return (
    <Modal open={open} onCancel={onCancel} title={t('title')} footer={null} width={460} destroyOnHidden>
      <div className="py-xs">
        <div className="mb-md text-sm text-brand-text-grey">{t('description')}</div>

        <Radio.Group
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          className="flex flex-col gap-xs"
        >
          {REASON_KEYS.map((key) => (
            <Radio key={key} value={key}>
              {t(`reasons.${key}`)}
            </Radio>
          ))}
        </Radio.Group>

        <div className="mt-lg">
          <div className="mb-2xs text-xs text-brand-text-grey">{t('details_label')}</div>
          <Input.TextArea
            value={details}
            onChange={(event) => setDetails(event.target.value)}
            placeholder={t('details_placeholder')}
            rows={3}
            maxLength={500}
            showCount
            disabled={!reason}
          />
        </div>

        <div className="mt-lg flex justify-end gap-xs">
          <Button onClick={onCancel}>{t('cancel')}</Button>
          <Button type="primary" onClick={handleConfirm} disabled={!reason}>
            {t('confirm')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
